var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotnet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.78,
    height: 227.78,
    viewBox: "0 0 227.78 227.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dotnet",
    transform: "translate(0.892)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 112.325,
    cy: 112.325,
    r: 112.325,
    transform: "translate(2.238)",
    fill: "#5c2d91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M36.708,9A112.325,112.325,0,1,0,195.3,167.589Z",
    transform: "translate(0 22.591)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M10.94,44.4a4.739,4.739,0,0,1-3.51-1.474A4.844,4.844,0,0,1,5.99,39.42a4.914,4.914,0,0,1,1.439-3.51A4.7,4.7,0,0,1,10.94,34.4a4.809,4.809,0,0,1,3.51,1.509,4.879,4.879,0,0,1,1.474,3.51,4.809,4.809,0,0,1-1.474,3.51A4.844,4.844,0,0,1,10.94,44.4Z",
    transform: "translate(17.274 86.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M64.119,82.76h-9.2L22.032,31.722a21.061,21.061,0,0,1-2.036-4h-.281a65.712,65.712,0,0,1,.351,8.775V82.76H12.59V18.77h9.723L54.326,68.9q2,3.124,2.6,4.282H57.1a67.675,67.675,0,0,1-.456-9.407v-45h7.477Z",
    transform: "translate(33.841 47.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M66.013,82.76H32V18.77H64.434v6.775H39.652V46.816h23.1v6.74h-23.1V75.74h26.4Z",
    transform: "translate(82.563 47.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M87.8,25.545H69.2V82.76H61.723V25.545H43.33V18.77H87.8Z",
    transform: "translate(111.003 47.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M41.87,69.89a17.3,17.3,0,0,1-8.144,1.72,13.128,13.128,0,0,1-10.074-4.037,14.953,14.953,0,0,1-3.791-10.53A15.655,15.655,0,0,1,24.109,45.6,14.462,14.462,0,0,1,34.92,41.247a17.305,17.305,0,0,1,7.02,1.229v3.51a14.041,14.041,0,0,0-7.02-1.755,10.741,10.741,0,0,0-8.249,3.51A12.777,12.777,0,0,0,23.512,56.8a12.18,12.18,0,0,0,2.949,8.6,10.039,10.039,0,0,0,7.757,3.194,14.532,14.532,0,0,0,7.687-1.966Z",
    transform: "translate(52.054 103.512)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M37.553,65.789a9.758,9.758,0,0,1-7.477-3.124A10.917,10.917,0,0,1,27.3,54.837a11.373,11.373,0,0,1,2.913-8.284,10.531,10.531,0,0,1,7.828-2.984,9.442,9.442,0,0,1,7.336,2.913,11.513,11.513,0,0,1,2.633,8.038,11.3,11.3,0,0,1-2.843,8.073,9.969,9.969,0,0,1-7.617,3.194Zm.246-19.2A6.424,6.424,0,0,0,32.674,48.8a9.091,9.091,0,0,0-1.9,6.108,8.6,8.6,0,0,0,1.9,5.9A6.494,6.494,0,0,0,37.8,62.981a6.178,6.178,0,0,0,5.02-2.106,9.2,9.2,0,0,0,1.755-6.037,9.337,9.337,0,0,0-1.755-6.073,6.143,6.143,0,0,0-5.02-2.176Z",
    transform: "translate(70.727 109.333)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M45.742,47.41a4.142,4.142,0,0,0-2.562-.667,4.317,4.317,0,0,0-3.51,2.036,9.407,9.407,0,0,0-1.439,5.546V65.066H34.72V44.005h3.51v4.388h0a7.371,7.371,0,0,1,2.211-3.51,5.019,5.019,0,0,1,3.3-1.229,5.511,5.511,0,0,1,2,.281Z",
    transform: "translate(89.391 109.564)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M56.939,55.543H42.091a7.863,7.863,0,0,0,1.79,5.406,6.529,6.529,0,0,0,4.984,1.9,10.53,10.53,0,0,0,6.529-2.352v3.159a12.215,12.215,0,0,1-7.336,2,8.916,8.916,0,0,1-7.02-2.878A11.759,11.759,0,0,1,38.476,54.7a11.513,11.513,0,0,1,2.773-8,8.951,8.951,0,0,1,7.02-3.089,7.933,7.933,0,0,1,6.388,2.668A11.162,11.162,0,0,1,56.9,53.718ZM53.429,52.7a7.02,7.02,0,0,0-1.4-4.528,4.809,4.809,0,0,0-3.861-1.615,5.441,5.441,0,0,0-4.037,1.72,7.758,7.758,0,0,0-2.071,4.458Z",
    transform: "translate(98.763 109.434)",
    fill: "#f2f2f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotnet);
export default __webpack_public_path__ + "static/media/dotnet.03bd289040ccc534b44fe9fd70ee2fac.svg";
export { ForwardRef as ReactComponent };